// nodemodule imports
import React from 'react';
import styled from "styled-components";

// project imports


export default ({section}) => {

  const formatText = (description) => {
    const replacements = description.replacements;
    let text = description.text;
    let substringArray = text.split(/[<>]/);

    if (replacements) {
      replacements.forEach((replacement) => {
        const key = Object.keys(replacement)[0];
        const i = substringArray.indexOf(key);
        let inlineTag;

        if(replacement[key] === '$code') {
          inlineTag = <Code>{key}</Code>;
        } else if(replacement[key] === '$bold') {
          inlineTag = <b>{key}</b>
        } else {
          inlineTag = <InlineAnchor href={replacement[key]}>{key}</InlineAnchor>;
        }

        substringArray.splice(i, 1, inlineTag)
      });
    }

    return substringArray;
  }

  return (
    <Wrapper>
      <Title>{section.title}</Title>
      {section.description.map((desc, index2) => {
        return (
          <TextSection>
            {
              desc.subtitle &&
              <Subtitle>{desc.subtitle}</Subtitle>
            }
            {formatText(desc)}
            {
              desc.list &&
              <List type={desc.list.type}>
                {desc.list.content.map(item => {
                  return (
                    <ListItem type={desc.list.type}>
                      {formatText(item)}
                    </ListItem>
                  )
                })}
              </List>
            }
          </TextSection>
        )
      })}
    </Wrapper>

  )
}
const List = styled.ul(props => ({
  padding: 0,
  paddingLeft: props.type === 'none' ? 0 : 20
}));
const ListItem = styled.li(props => ({
  listStyleType: props.type,
}));

const Title = styled.p(props => ({
  fontWeight: 500,
  fontSize: 24,
  lineHeight: '150%'
}));

const Subtitle = styled.p(props => ({
  fontWeight: 500,
  fontSize: 16,
  lineHeight: 'auto',
  margin: '30px 0 7px 0'
}));

const Wrapper = styled.div(props => ({
  width:"calc(100% - 570px)",
  marginRight: 70,
  "@media (max-width: 1280px)": {
    width:"calc(100% - 430px)",
    marginRight: 30,
  },
  "@media (max-width: 1080px)": {
    width:"calc(100% - 30px)",
  },
}));
const InlineAnchor = styled.a(props => ({
  textDecoration: 'none',
  color: "#1F4AAD"
}));

const Code = styled.code(props => ({
  background: "#FFFFFF",
  border: "1px solid rgba(31, 74, 173, 0.3)",
  boxSizing: "border-box",
  boxShadow: "inset 0px 0px 30px rgba(0, 0, 0, 0.04)",
  borderRadius: "2px",
  padding: "0 3px 0 3px"
}));


const TextSection = styled.p(props => ({
  margin: 0,
  padding: 0,
  fontSize: 14,
  lineHeight: 'auto',
  marginBottom: 20
}));